// METHOD: Keyboard trap
var currentFocus;
$.fn.trapKeyboardActiveMenu = function(options) {
    $this = $(this);
    
    currentFocus = $(':focus');
    
    // Setting defaults
    settings = $.extend({
        'firstTabbableElement': false,
        'lastTabbableElement': false
    }, options);
    
    var tabbable = $this.find(
        'a[href],' +
        'area[href],' +
        'input:not([disabled]),' +
        'select:not([disabled]),' +
        'textarea:not([disabled]),' +
        'button:not([disabled]),' +
        'iframe,' +
        'object,' +
        'embed,' +
        '[tabindex="0"],' +
        '[contenteditable]'
    );

    var firstTabbable = (settings.firstTabbableElement !== false) ? settings.firstTabbableElement : tabbable.first();
    var lastTabbable = (settings.lastTabbableElement !== false) ? settings.lastTabbableElement : tabbable.last();
        
    // TODO: Escape key press
    // $this.on('keydown', function(e) {
    //     if (e.keyCode === 27 && $('.menu-sub.active').length) {
    //         e.preventDefault();
    //         $('.menu-sub.active')
    //             .find('.back:first')
    //             .trigger('click');
    //         return false;
    //     }
    // });


    // Redirect last tab to first input
    lastTabbable.on('keydown', function(e) {
        if (e.which === 9 && !e.shiftKey) {
            e.preventDefault();
            firstTabbable.focus();
        }
    });

    // Redirect first shift+tab to last input
    firstTabbable.on('keydown', function(e) {
        if (e.which === 9 && e.shiftKey) {
            e.preventDefault();
            lastTabbable.focus();
        }
    });
    
    // Set focus on first focusable item
    setTimeout(function(){
        firstTabbable.focus();
    }, 100);
};